import script from "./WrongQuestionCartDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./WrongQuestionCartDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./WrongQuestionCartDrawer.vue?vue&type=style&index=0&id=128ecab1&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128ecab1"]])

export default __exports__